import { Box, themeGet } from '@primer/react';
import capitalize from 'lodash/capitalize';
import React from 'react';
import LTCounterLabel from '../LTCounterLabel/index.js';
import LTIconButton from '../LTIconButton/index.js';
import LTPopover from '../LTPopover/index.js';
import LTTag from '../LTTags/index.js';
import LTText from '../LTText/index.js';
import LTTestStatusLabel from '../LTTestStatusLabel/index.js';
import LTTooltip from '../LTTooltip/index.js';
import { TestHeaderContainer, TopHeaderBar, BuildHeaderName, BuildName, TestFooterWrapper, TestFooter, FooterItem, Dot, StyledBox, StyledText } from './styles.js';
import { truncateTextFromMiddle } from '../../utils/functions.js';
import ChevronLeft from '../../icons/ChevronLeft.js';

// @ts-nocheck
/**
 * Header component for displaying Test information.
 * This card will be used in Automation (Web + App)
 * @param {string} buildName The name of the build.
 * @param {Element} headerActions The actions available on the build / test.
 * @param {string} status The status of the build.
 * @param {number} testCount The total tests in the build.
 * @param {string} timeSince Time since the build was ran.
 * @param {string} totalTime The total time of the build.
 * @param {Element} secondaryActions The actions to be added on the test.
 * @param {string} username The user who ran the build.
 */
var ToolTipTag = function ToolTipTag(_a) {
  var tags = _a.tags,
    totalCount = _a.totalCount;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      gap: themeGet("space.2"),
      alignItems: "start",
      flexDirection: "column"
    }
  }, tags.slice(2, totalCount).map(function (tag, index) {
    var _a = (tag || {}).name,
      name = _a === void 0 ? "" : _a;
    return /*#__PURE__*/React.createElement(LTTooltip, {
      text: name,
      key: "".concat(name, "-").concat(index)
    }, /*#__PURE__*/React.createElement(LTTag, {
      text: name
    }));
  }));
};
var LTTestHeader = function LTTestHeader(_a) {
  var _b = _a.accessibilityIcon,
    AccessibilityIcon = _b === void 0 ? null : _b,
    _c = _a.title,
    title = _c === void 0 ? "" : _c,
    _d = _a.browser,
    browser = _d === void 0 ? "" : _d,
    _e = _a.browserIcon,
    browserIcon = _e === void 0 ? "" : _e,
    _f = _a.clockIcon,
    ClockIcon = _f === void 0 ? null : _f,
    _g = _a.osName,
    osName = _g === void 0 ? "" : _g,
    _h = _a.heading,
    heading = _h === void 0 ? "" : _h,
    _j = _a.headerActions,
    headerActions = _j === void 0 ? undefined : _j,
    _k = _a.headingId,
    headingId = _k === void 0 ? "" : _k,
    _l = _a.isAccessibilityEnabled,
    isAccessibilityEnabled = _l === void 0 ? false : _l,
    _m = _a.isTunnelActive,
    isTunnelActive = _m === void 0 ? "" : _m,
    _o = _a.project,
    project = _o === void 0 ? "" : _o,
    _p = _a.projectIcon,
    projectIcon = _p === void 0 ? "" : _p,
    _q = _a.osIcon,
    osIcon = _q === void 0 ? "" : _q,
    _r = _a.osVersion,
    osVersion = _r === void 0 ? "" : _r,
    _s = _a.resolution,
    resolution = _s === void 0 ? "" : _s,
    _t = _a.resolutionIcon,
    resolutionIcon = _t === void 0 ? "" : _t,
    _u = _a.status,
    status = _u === void 0 ? "passed" : _u,
    _v = _a.statusIconSrc,
    statusIconSrc = _v === void 0 ? "" : _v,
    _w = _a.taskIcon,
    taskIcon = _w === void 0 ? "" : _w,
    _x = _a.testCount,
    testCount = _x === void 0 ? 0 : _x,
    _y = _a.timeSince,
    timeSince = _y === void 0 ? "" : _y,
    _z = _a.totalTime,
    totalTime = _z === void 0 ? "" : _z,
    _0 = _a.tunnelIcon,
    TunnelIcon = _0 === void 0 ? null : _0,
    _1 = _a.username,
    username = _1 === void 0 ? "" : _1,
    _2 = _a.version,
    version = _2 === void 0 ? "" : _2,
    _3 = _a.buildTypeImg,
    buildTypeImg = _3 === void 0 ? "" : _3,
    _4 = _a.showHeaderBtn,
    showHeaderBtn = _4 === void 0 ? false : _4,
    _5 = _a.tags,
    tags = _5 === void 0 ? [] : _5,
    _6 = _a.type,
    type = _6 === void 0 ? "" : _6,
    _7 = _a.handleHeaderBtnClick,
    handleHeaderBtnClick = _7 === void 0 ? function () {} : _7,
    _8 = _a.headerBtnTooltip,
    headerBtnTooltip = _8 === void 0 ? "" : _8,
    secondaryActions = _a.secondaryActions;
  var totalTags = Array.isArray(tags) ? tags.length : 0;
  var remainingTagCount = Array.isArray(tags) ? totalTags - 2 : 0;
  return /*#__PURE__*/React.createElement(TestHeaderContainer, null, /*#__PURE__*/React.createElement(TopHeaderBar, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, showHeaderBtn && /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: "-12px"
    }
  }, /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: headerBtnTooltip
  }, /*#__PURE__*/React.createElement(LTIconButton, {
    "aria-label": "Go Back",
    icon: ChevronLeft,
    variant: "invisible",
    onClick: handleHeaderBtnClick
  }))), /*#__PURE__*/React.createElement(BuildHeaderName, {
    as: "h5",
    variant: LTText.TextVariant.SMALL_BOLD
  }, title)), /*#__PURE__*/React.createElement("div", null, headerActions ? /*#__PURE__*/React.createElement(React.Fragment, null, headerActions) : /*#__PURE__*/React.createElement(React.Fragment, null))), /*#__PURE__*/React.createElement(BuildName, {
    as: "h3",
    id: headingId,
    variant: LTText.TextVariant.HEADER_BOLD
  }, heading), /*#__PURE__*/React.createElement(TestFooterWrapper, null, /*#__PURE__*/React.createElement(TestFooter, null, /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(LTTestStatusLabel, {
    iconSrc: statusIconSrc,
    status: status,
    width: "20",
    height: "20"
  })), testCount ? /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: "Total Tests"
  }, /*#__PURE__*/React.createElement(StyledBox, {
    className: "totalTests"
  }, /*#__PURE__*/React.createElement("img", {
    src: taskIcon,
    alt: "Total Tests",
    height: "16",
    width: "16"
  }), /*#__PURE__*/React.createElement(StyledText, {
    sx: {
      fontWeight: "400 !important",
      color: "#666"
    }
  }, "Tests"), /*#__PURE__*/React.createElement(StyledText, null, testCount)))) : null, version && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: capitalize(browser)
  }, /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement("img", {
    src: browserIcon,
    alt: "".concat(capitalize(browser) || version, " browser"),
    height: "16",
    width: "16"
  }), /*#__PURE__*/React.createElement(StyledText, null, version)))), osVersion && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: capitalize(osName)
  }, /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement("img", {
    src: osIcon,
    alt: "".concat(capitalize(osName) || osVersion, " os"),
    height: "20",
    width: "20"
  }), /*#__PURE__*/React.createElement(StyledText, null, osVersion)))), resolution && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: "Resolution"
  }, /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement("img", {
    src: resolutionIcon,
    alt: "".concat(resolution, " resolution"),
    height: "16",
    width: "16"
  }), /*#__PURE__*/React.createElement(StyledText, null, resolution)))), project && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: project.length > 30 ? project : undefined
  }, /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement("img", {
    src: projectIcon,
    alt: "Project",
    height: "16",
    width: "16"
  }), /*#__PURE__*/React.createElement(StyledText, {
    sx: {
      fontWeight: "400 !important",
      color: "#666"
    }
  }, "Project"), /*#__PURE__*/React.createElement(StyledText, null, truncateTextFromMiddle(project, 30))))), totalTime && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: "Total Time"
  }, /*#__PURE__*/React.createElement(StyledBox, {
    className: "totalTestTime"
  }, /*#__PURE__*/React.createElement(ClockIcon, null), /*#__PURE__*/React.createElement(StyledText, null, totalTime)))), (timeSince || username) && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(StyledBox, null, timeSince && /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: "Time Since"
  }, /*#__PURE__*/React.createElement(StyledText, {
    className: "timeSince",
    sx: {
      fontWeight: "400 !important",
      color: "#666"
    }
  }, timeSince, " by")), username && /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: "Username"
  }, /*#__PURE__*/React.createElement(StyledText, {
    className: "username"
  }, username)))), buildTypeImg && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: capitalize(type)
  }, /*#__PURE__*/React.createElement("img", {
    src: buildTypeImg,
    alt: "".concat(capitalize(type), " build"),
    height: "20",
    width: "20"
  }))), isTunnelActive !== "" && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: "Tunnel ".concat(isTunnelActive ? "On" : "Off")
  }, /*#__PURE__*/React.createElement(StyledBox, {
    className: "tunnelActiveStatus"
  }, /*#__PURE__*/React.createElement(TunnelIcon, {
    color: isTunnelActive ? "#176F2C" : "#666"
  }), /*#__PURE__*/React.createElement(StyledText, null, isTunnelActive ? "ON" : "OFF")))), isAccessibilityEnabled && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement(AccessibilityIcon, null), /*#__PURE__*/React.createElement(StyledText, null, "Accessibility Enabled"))), tags && tags.length > 0 && /*#__PURE__*/React.createElement(FooterItem, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      gap: themeGet("space.2"),
      alignItems: "center"
    }
  }, tags.slice(0, 2).map(function (tag, index) {
    var _a = (tag || {}).name,
      name = _a === void 0 ? "" : _a;
    return /*#__PURE__*/React.createElement(LTTooltip, {
      text: name,
      key: "".concat(name, "-").concat(index)
    }, /*#__PURE__*/React.createElement(LTTag, {
      text: name
    }));
  }), remainingTagCount > 0 && /*#__PURE__*/React.createElement(LTPopover, {
    text: /*#__PURE__*/React.createElement(ToolTipTag, {
      totalCount: totalTags,
      tags: tags
    })
  }, /*#__PURE__*/React.createElement(LTCounterLabel, {
    count: "+".concat(remainingTagCount),
    scheme: LTCounterLabel.Scheme.OUTLINED
  }))))), secondaryActions ? /*#__PURE__*/React.createElement(React.Fragment, null, secondaryActions) : /*#__PURE__*/React.createElement(React.Fragment, null)));
};

export { LTTestHeader as default };
